import { ObservableArray, View, ViewModel } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { ListViewModel } from "./list-viewModel"

export class ListView extends FormBuilderComponentView<ListViewModel>{
    GetViewUniqueId(): string {
        return "V-0D7151F6-647A-427F-BEF5-32E5FE547336"
    }
    loadHtml(): string {
        let element = require('./list.html').default;
        let style = require('./list.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set ItemsSource(v: ObservableArray<ViewModel>) { this._ItemsSource = v; } public get ItemsSource(): ObservableArray<ViewModel> { return this._ItemsSource;} private _ItemsSource: ObservableArray<ViewModel>;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;

}
